import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { HomeWorkComponent } from './home-work/home-work.component';


const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
       { path: 'adminhomework', component: HomeWorkComponent, pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeworkRoutingModule { }
